import { useContext } from 'react';
import { DialogContext } from '../contexts/DialogContext';

/**
 * Hook to access dialog functions
 * @returns {Object} { confirm, alert }
 */
function useDialog() {
  const context = useContext(DialogContext);
  
  if (!context) {
    throw new Error('useDialog must be used within a DialogProvider');
  }
  
  return context;
}

export default useDialog;
